import { Pipe, PipeTransform, inject } from '@angular/core';
import {ThuisverzorgerDienst} from './thuisverzorger-dienst';
import {Diensten} from '../dienst/diensten';
import {DienstenPipe} from '../dienst/diensten.pipe';
import {Zone} from '../zone/zone';

@Pipe({
    name: 'zahThuisverzorgerDiensten',
    standalone: false
})
export class ThuisverzorgerDienstenPipe implements PipeTransform {
  private dienstenPipe = inject(DienstenPipe);

  transform(thuisverzorgerDiensten: Array<ThuisverzorgerDienst>, diensten: Diensten, zones: Array<Zone>): string {
    if (!diensten || !zones) {
      return '';
    } else {
      const clientDienstLabels = (thuisverzorgerDiensten || [])
        .map(thuisverzorgerDienst =>
          `${this.getDienstLabel(thuisverzorgerDienst.getId(), diensten)} - ${this.getZoneLabels(thuisverzorgerDienst.getZoneIds(), zones)}`
        );
      return clientDienstLabels.length > 0 ? clientDienstLabels.join('; ') : 'Geen dienst';
    }
  }

  private getDienstLabel(dienstId: string, diensten: Diensten): string {
    return diensten.getDienst(dienstId)?.getLabel() || 'Onbekende dienst';
  }

  private getZoneLabels(zoneIds: Array<string>, zones: Array<Zone>): string {
    return zoneIds.map(zoneId => zones.find(zone => zone.getId() === zoneId)?.getLabel() || 'Onbekende zone').join(', ');
  }
}
